var getBarraHerramientas = function getBarraHerramientas(state) {
  return state.barraHerramientas;
};

export var getHerramientaIdSeleccionado = function getHerramientaIdSeleccionado(state) {
  return getBarraHerramientas(state).herramientaIdSeleccionado;
};
export var getGrupoSeleccionado = function getGrupoSeleccionado(state) {
  return getBarraHerramientas(state).grupoSeleccionado;
};
export var getPosicion = function getPosicion(state) {
  return getBarraHerramientas(state).posicion;
};
export var getVisible = function getVisible(state) {
  return getBarraHerramientas(state).visible;
};
export var punteroAlOcultar = function punteroAlOcultar(state) {
  return getBarraHerramientas(state).punteroAlOcultar;
};
export var getBotones = function getBotones(state) {
  return getBarraHerramientas(state).botones;
};
export var getBoton = function getBoton(state, herremientaId) {
  return getBotones(state).find(function (_ref) {
    var id = _ref.id;
    return id === herremientaId;
  });
};